<template>
  <b-card-body no-body>
    <b-form-row  @keyup.enter="buscarDepartamentoEmails" class="pt-3">
      <b-col cols="8" class="d-flex justify-content-center align-items-center">
        <lg-form-input v-model="filtro" label="Unidade Administrativa ou e-mail:"
          />
      </b-col>

      <b-col cols="4" class="d-flex justify-content-center align-items-center">
        <b-button id="btnAdicionar" class="mr-2 my-2" size="sm" pill variant="primary" @click="mostrarModal">
          <div class="btn-size-alinhamento">

            <b-icon icon="plus" />
            <b-tooltip target="btnAdicionar" title="Adicionar novo..."></b-tooltip>
          </div>
        </b-button>

        <b-button id="btnBuscarAdm" class="mr-2 my-2" size="sm" pill variant="primary" @click="buscarDepartamentoEmails">
          <div class="btn-size-alinhamento">

            <b-icon icon="search" />
            <b-tooltip target="btnBuscarAdm" title="Buscar"></b-tooltip>
          </div>
        </b-button>

        <b-button id="btnLimparAdm" class="mr-2 my-2" size="sm" pill variant="primary" @click="limparFiltro">
          <div class="btn-size-alinhamento">

            <b-icon icon="eraser" />
            <b-tooltip target="btnLimparAdm" title="Limpar"></b-tooltip>
          </div>
        </b-button>
      </b-col>
    </b-form-row>

    <b-table responsive small class="mt-2" :busy="busy" :hover="true" show-empty :items="departamentoEmails"
      :fields="camposTabela">
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Carregando...</strong>
        </div>
      </template>

      <template #empty>
        <p>Nenhum registro encontrado</p>
      </template>
    </b-table>

    <PainelConfiguracaoUnidadeAdministrativaForm v-if="showModal" @close="fecharModal"
      @salvo="buscarDepartamentoEmails" />
  </b-card-body>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import PainelConfiguracaoUnidadeAdministrativaForm from "./PainelConfiguracaoUnidadeAdministrativaForm.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
  components: {
    LgFormInput,
    PainelConfiguracaoUnidadeAdministrativaForm,
  },
  data() {
    return {
      busy: false,
      filtro: "",
      departamentoEmails: [],
      showModal: false,
      camposTabela: [
        { key: "descricaoDepartamento", label: "Unidade Administrativa" },
        { key: "email", label: "E-mail" },
      ],
    };
  },
  methods: {
    async buscarDepartamentoEmails() {
      this.busy = true;
      const response = await ConfiguracaoSistemaService.buscarDepartamentoEmails(this.filtro);
      this.departamentoEmails = response.data;
      this.busy = false;
    },
    mostrarModal() {
      this.showModal = true;
    },
    fecharModal() {
      this.showModal = false;
    },
    limparFiltro() {
      this.filtro = "";
      this.departamentoEmails = [];
      this.buscarDepartamentoEmails();
    },
  },
  async mounted() {
    await this.buscarDepartamentoEmails();
  },
};
</script>
